import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { units } from '../../utils/spacing';
import { fontSize, FontSizes, fontWeight, FontWeights, lineHeight } from '../../utils/typography';

export const Wrapper = styled.div<{
	$disabled: boolean;
	$maxWidth?: string;
}>`
	background: ${palette('white')};
	width: 100%;

	margin-bottom: ${units(2)};
	border: 1px solid ${palette('gray1')};
	border-radius: 6px;

	box-sizing: border-box;
	max-width: ${p => p.$maxWidth ?? 'unset'};
	position: relative;

	${ifProp(
		'$disabled',
		css`
			opacity: 0.5;
		`,
	)}
`;

export const Inner = styled.div<{
	$innerMaxWidth?: string;
	$noPadding: boolean;
}>`
	width: 100%;
	max-width: ${p => p.$innerMaxWidth ?? 'unset'};

	${ifProp(
		'$noPadding',
		css`
			padding: 0px;
		`,
		css`
			padding: ${units(2)};
		`,
	)}
`;

// Automatically disables clicking things on the cell
export const DisabledCursorBlocker = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	opacity: 0.5;
	z-index: 1;
`;

export const WarningContainer = styled.div`
	background: ${palette('gold')};
`;

export const WarningText = styled.p`
	padding: ${units(0.75)} ${units(2)};
	${fontSize(FontSizes.sm)}
	${lineHeight(FontSizes.sm)}
	${fontWeight(FontWeights.Medium)}
	color: ${palette('gray8')};
`;
